export default function getStockCountByOutlet(outletId, stock) {
  if (stock === undefined || stock.length === 0) return 0
  return stock.reduce((count, stock) => {
    if (stock.id === outletId) return count + stock.count
    else return count
  }, 0)
}
